import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCalendarAlt,
  faCheckCircle,
  faCircle,
  faClipboard,
  faClock,
  faEnvelope,
  faEye,
  faFileAlt,
  faHospital,
  faTrashAlt
} from '@fortawesome/free-regular-svg-icons'

library.add(faCalendarAlt)
library.add(faCheckCircle)
library.add(faCircle)
library.add(faClipboard)
library.add(faClock)
library.add(faEnvelope)
library.add(faEye)
library.add(faFileAlt)
library.add(faHospital)
library.add(faTrashAlt)
